/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import './src/styles/global.css'
// import "./src/fonts/satoshi/Satoshi-Regular.woff2";
// import "./src/fonts/satoshi/Satoshi-Bold.woff2";
import "./src/styles/global.css";  

// Prism theme for syntax highlighting in Markdown code fences
import "prismjs/themes/prism-tomorrow.css";
// PrismJS theme and copy-to-clipboard toolbar for code blocks
// Prism/Remark will output <pre><code>. Add a lightweight copy button on code blocks.
function resetScrollContainersToTop() {
  if (typeof document === "undefined") return
  try {
    const containers = [
      document.getElementById("content"),
      document.getElementById("gatsby-focus-wrapper"),
      document.getElementById("___gatsby"),
      document.scrollingElement || null,
      document.documentElement || null,
      document.body || null,
    ].filter(Boolean)

    const jumpToTop = (el) => {
      try {
        // Prefer the options signature to override CSS smooth scrolling
        el.scrollTo({ top: 0, left: 0, behavior: "auto" })
      } catch (_) {
        try { el.scrollTop = 0 } catch (_) {}
        try { typeof el.scrollTo === "function" && el.scrollTo(0, 0) } catch (_) {}
      }
      try { el.scrollTop = 0 } catch (_) {}
    }

    containers.forEach(jumpToTop)
    try { window.scrollTo({ top: 0, left: 0, behavior: "auto" }) } catch (_) {
      try { window.scrollTo(0, 0) } catch (_) {}
    }

    // Safari sometimes needs a second pass once layout stabilizes
    try {
      requestAnimationFrame(() => {
        containers.forEach((el) => { try { el.scrollTop = 0 } catch (_) {} })
        try { window.scrollTo({ top: 0, left: 0, behavior: "auto" }) } catch (_) {
          try { window.scrollTo(0, 0) } catch (_) {}
        }
      })
    } catch (_) {}
  } catch (_) {}
}
export const onRouteUpdate = ({ location }) => {
  if (typeof document === "undefined") return
  try {
    if (typeof window !== "undefined" && window.history && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"
    }
  } catch (_) {}
  // Toggle root gradient for non-home routes only
  try {
    const isHome = window && window.location && (window.location.pathname === "/" || window.location.pathname === "");
    document.documentElement.classList.toggle("no-root-gradient", !!isHome);
  } catch (_) {}
  // Ensure we reset scroll position on route changes (except when navigating to a hash)
  try {
    const hasHash = location && typeof location.hash === "string" && location.hash.length > 1
    if (!hasHash) {
      resetScrollContainersToTop()
    }
  } catch (_) {}
  // Initialize or rebind the underwater lamp cursor on navigation
  try {
    if (typeof window !== "undefined" && window.__cleanupUnderwaterLampCursor) {
      window.__cleanupUnderwaterLampCursor();
    }
    initUnderwaterLampCursor();
  } catch (_) {}
  const blocks = document.querySelectorAll("pre > code");
  blocks.forEach((code) => {
    const pre = code.parentElement
    if (!pre || pre.dataset.copyBound) return
    pre.dataset.copyBound = "true"
    const btn = document.createElement("button")
    btn.type = "button"
    btn.textContent = "Copy"
    btn.style.position = "absolute"
    btn.style.top = "8px"
    btn.style.right = "8px"
    btn.style.padding = "4px 8px"
    btn.style.fontSize = "11px"
    btn.style.borderRadius = "6px"
    btn.style.background = "rgba(255,255,255,0.08)"
    btn.style.color = "#fff"
    btn.style.border = "1px solid rgba(255,255,255,0.12)"
    btn.style.cursor = "pointer"
    btn.style.backdropFilter = "blur(2px)"
    pre.style.position = pre.style.position || "relative"
    pre.appendChild(btn)
    btn.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(code.innerText)
        btn.textContent = "Copied"
        setTimeout(() => (btn.textContent = "Copy"), 1200)
      } catch (_) {
        btn.textContent = "Failed"
        setTimeout(() => (btn.textContent = "Copy"), 1200)
      }
    })
  })
}

// Add scroll-smooth to <body> via DOM API
export const onInitialClientRender = () => {
    document.body.classList.add("scroll-smooth")
    // Ensure correct state on first load as well
    try {
      const isHome = window && window.location && (window.location.pathname === "/" || window.location.pathname === "");
      document.documentElement.classList.toggle("no-root-gradient", !!isHome);
    } catch (_) {}
    try {
      if (typeof window !== "undefined" && window.__cleanupUnderwaterLampCursor) {
        window.__cleanupUnderwaterLampCursor();
      }
      initUnderwaterLampCursor();
    } catch (_) {}
  }

// --- Underwater lamp cursor implementation (CSS in global.css) ---
function initUnderwaterLampCursor() {
  if (typeof document === "undefined" || typeof window === "undefined") return
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

  // Only for fine pointers (mouse/trackpad)
  const isFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches
  if (!isFinePointer) {
    // Ensure element removed if present on touch devices
    const existing = document.getElementById('underwater-lamp-cursor')
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing)
    const ring = document.getElementById('cursor-ring')
    if (ring && ring.parentNode) ring.parentNode.removeChild(ring)
    return
  }

  const root = document.documentElement
  const isLightTheme = root.getAttribute('data-theme') === 'light'

  // If light theme -> use a subtle cursor dot + soft trailing glow instead of the lamp
  if (isLightTheme) {
    // Remove lamp if it exists
    const existingLamp = document.getElementById('underwater-lamp-cursor')
    if (existingLamp && existingLamp.parentNode) existingLamp.parentNode.removeChild(existingLamp)

    // Clean up any previous ring element from older versions
    const oldRing = document.getElementById('cursor-ring')
    if (oldRing && oldRing.parentNode) oldRing.parentNode.removeChild(oldRing)

    // No central dot in light mode; use elegant ring + soft trail only
    // Elegant ring that softly follows and reacts to interactive targets
    let ring = document.getElementById('cursor-ring')
    if (!ring) {
      ring = document.createElement('div')
      ring.id = 'cursor-ring'
      ring.style.setProperty('--ring-size', '26px')
      ring.style.setProperty('--ring-opacity', '0.22')
      ring.style.setProperty('--ring-color', 'rgb(15,23,42)') // slate-900 fallback
      document.body.appendChild(ring)
    }
    let trail = document.getElementById('cursor-trail')
    if (!trail) {
      trail = document.createElement('div')
      trail.id = 'cursor-trail'
      trail.style.setProperty('--trail-size', '18px')
      trail.style.setProperty('--trail-opacity', '0.22')
      document.body.appendChild(trail)
    }

    let targetX = window.innerWidth / 2
    let targetY = window.innerHeight / 2
    let trailX = targetX, trailY = targetY
    let ringX = targetX, ringY = targetY
    let rafId = null
    let lastMoveTs = performance.now()
    let hoveringInteractive = false

    const onPointerMove = (e) => {
      targetX = e.clientX
      targetY = e.clientY
      lastMoveTs = performance.now()
      // Detect interactive elements under pointer
      try {
        const tgt = e.target
        const interactive = tgt && (tgt.closest && tgt.closest('a, button, [role="button"], input, select, textarea, .cursor-pointer'))
        hoveringInteractive = !!interactive
        if (interactive) {
          const cs = window.getComputedStyle(interactive)
          const color = cs && cs.color ? cs.color : 'rgb(15,23,42)'
          ring.style.setProperty('--ring-color', color)
          ring.style.setProperty('--ring-size', '36px')
          ring.style.setProperty('--ring-opacity', '0.30')
        } else {
          ring.style.setProperty('--ring-size', '26px')
          ring.style.setProperty('--ring-opacity', '0.22')
        }
      } catch (_) {}
      if (!rafId) rafId = requestAnimationFrame(tick)
    }
    const onMouseMove = (e) => {
      targetX = e.clientX
      targetY = e.clientY
      lastMoveTs = performance.now()
      try {
        const tgt = e.target
        const interactive = tgt && (tgt.closest && tgt.closest('a, button, [role="button"], input, select, textarea, .cursor-pointer'))
        hoveringInteractive = !!interactive
        if (interactive) {
          const cs = window.getComputedStyle(interactive)
          const color = cs && cs.color ? cs.color : 'rgb(15,23,42)'
          ring.style.setProperty('--ring-color', color)
          ring.style.setProperty('--ring-size', '36px')
          ring.style.setProperty('--ring-opacity', '0.30')
        } else {
          ring.style.setProperty('--ring-size', '26px')
          ring.style.setProperty('--ring-opacity', '0.22')
        }
      } catch (_) {}
      if (!rafId) rafId = requestAnimationFrame(tick)
    }
    const onVisibility = () => {
      const hidden = document.hidden
      trail.style.opacity = hidden ? '0' : 'var(--trail-opacity, 0.22)'
      ring.style.opacity = hidden ? '0' : 'var(--ring-opacity, 0.22)'
    }
    const onDown = () => {
      try {
        ring.style.transform = 'translate(-50%, -50%) scale(0.95)'
        trail.style.setProperty('--trail-size', '22px')
      } catch (_) {}
    }
    const onUp = () => {
      try {
        ring.style.transform = 'translate(-50%, -50%) scale(1)'
        trail.style.setProperty('--trail-size', '18px')
      } catch (_) {}
    }

    const tick = (ts) => {
      const dt = Math.min(32, (ts - (tick.prevTs || ts)))
      tick.prevTs = ts
      const ringSpeed = hoveringInteractive ? 0.20 : 0.18
      const trailSpeed = 0.10
      ringX += (targetX - ringX) * ringSpeed
      ringY += (targetY - ringY) * ringSpeed
      trailX += (targetX - trailX) * trailSpeed
      trailY += (targetY - trailY) * trailSpeed
      ring.style.left = `${ringX}px`
      ring.style.top = `${ringY}px`
      trail.style.left = `${trailX}px`
      trail.style.top = `${trailY}px`

      const idleMs = ts - lastMoveTs
      const trailOpacity = idleMs > 2400 ? 0.16 : 0.22
      const ringOpacity = idleMs > 2400 ? 0.18 : (hoveringInteractive ? 0.30 : 0.22)
      trail.style.setProperty('--trail-opacity', trailOpacity.toString())
      ring.style.setProperty('--ring-opacity', ringOpacity.toString())

      rafId = requestAnimationFrame(tick)
    }

    if (!root.dataset.lampBound) {
      const supportsPointer = typeof window !== 'undefined' && 'onpointermove' in window
      if (supportsPointer) {
        window.addEventListener('pointermove', onPointerMove, { passive: true })
      } else {
        window.addEventListener('mousemove', onMouseMove, { passive: true })
      }
      document.addEventListener('visibilitychange', onVisibility)
      window.addEventListener('mousedown', onDown, { passive: true })
      window.addEventListener('mouseup', onUp, { passive: true })
      root.dataset.lampBound = 'true'
    }
    if (!rafId) rafId = requestAnimationFrame(tick)

    window.__cleanupUnderwaterLampCursor = () => {
      try {
        window.removeEventListener('pointermove', onPointerMove)
        window.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('visibilitychange', onVisibility)
        window.removeEventListener('mousedown', onDown)
        window.removeEventListener('mouseup', onUp)
        if (rafId) cancelAnimationFrame(rafId)
        rafId = null
        const lamp = document.getElementById('underwater-lamp-cursor')
        if (lamp && lamp.parentNode) lamp.parentNode.removeChild(lamp)
        const dotNow = document.getElementById('cursor-dot')
        if (dotNow && dotNow.parentNode) dotNow.parentNode.removeChild(dotNow)
        const ringNow = document.getElementById('cursor-ring')
        if (ringNow && ringNow.parentNode) ringNow.parentNode.removeChild(ringNow)
        const trailNow = document.getElementById('cursor-trail')
        if (trailNow && trailNow.parentNode) trailNow.parentNode.removeChild(trailNow)
        delete document.documentElement.dataset.lampBound
      } catch (_) {}
    }
    return
  }

  let lamp = document.getElementById('underwater-lamp-cursor')
  if (!lamp) {
    lamp = document.createElement('div')
    lamp.id = 'underwater-lamp-cursor'
    // base inline vars; full visuals in CSS
    lamp.style.setProperty('--lamp-size', '800px')
    lamp.style.setProperty('--lamp-blur', '18px')
    lamp.style.setProperty('--lamp-opacity', '0.58')
    document.body.appendChild(lamp)
  }

  // Track mouse with slight smoothing
  let targetX = window.innerWidth / 2
  let targetY = window.innerHeight / 2
  let currentX = targetX
  let currentY = targetY
  let rafId = null
  let lastMoveTs = performance.now()
  let baseSize = 800

  const onPointerMove = (e) => {
    targetX = e.clientX
    targetY = e.clientY
    lastMoveTs = performance.now()
    if (!rafId) rafId = requestAnimationFrame(tick)
  }

  // Fallback for environments where pointer events may not fire
  const onMouseMove = (e) => {
    targetX = e.clientX
    targetY = e.clientY
    lastMoveTs = performance.now()
    if (!rafId) rafId = requestAnimationFrame(tick)
  }

  const onVisibility = () => {
    const hidden = document.hidden
    lamp.style.opacity = hidden ? '0' : 'var(--lamp-opacity, 0.85)'
  }

  // Gentle spring-ish follow without shimmer (no flicker)
  const tick = (ts) => {
    const dt = Math.min(32, (ts - (tick.prevTs || ts)))
    tick.prevTs = ts

    // Ease current towards target (critically damped-ish)
    const followSpeed = 0.18
    currentX += (targetX - currentX) * followSpeed
    currentY += (targetY - currentY) * followSpeed
    // Position via left/top to avoid any transform-order edge cases
    lamp.style.left = `${currentX}px`
    lamp.style.top = `${currentY}px`

    // Subtle size response to movement speed (smoothed)
    const vx = targetX - currentX
    const vy = targetY - currentY
    const speed = Math.hypot(vx, vy)
    const targetSize = baseSize + Math.min(10, speed * 0.05)
    tick.currentSize = (typeof tick.currentSize === 'number') ? tick.currentSize : baseSize
    tick.currentSize += (targetSize - tick.currentSize) * 0.12
    lamp.style.setProperty('--lamp-size', `${tick.currentSize.toFixed(1)}px`)

    // Auto fade when idle
    const idleMs = ts - lastMoveTs
    const targetOpacity = idleMs > 2800 ? 0.42 : 0.58
    lamp.style.setProperty('--lamp-opacity', targetOpacity.toString())

    rafId = requestAnimationFrame(tick)
  }

  // Debounce multiple bindings across route changes
  if (!root.dataset.lampBound) {
    const supportsPointer = typeof window !== 'undefined' && 'onpointermove' in window
    if (supportsPointer) {
      window.addEventListener('pointermove', onPointerMove, { passive: true })
    } else {
      window.addEventListener('mousemove', onMouseMove, { passive: true })
    }
    document.addEventListener('visibilitychange', onVisibility)
    root.dataset.lampBound = 'true'
  }

  if (!rafId) rafId = requestAnimationFrame(tick)

  // Expose a cleanup to avoid duplicates during hot reloads
  window.__cleanupUnderwaterLampCursor = () => {
    try {
      window.removeEventListener('pointermove', onPointerMove)
      window.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('visibilitychange', onVisibility)
      if (rafId) cancelAnimationFrame(rafId)
      rafId = null
      if (lamp && lamp.parentNode) lamp.parentNode.removeChild(lamp)
      const dotNow = document.getElementById('cursor-dot')
      if (dotNow && dotNow.parentNode) dotNow.parentNode.removeChild(dotNow)
      const ringNow = document.getElementById('cursor-ring')
      if (ringNow && ringNow.parentNode) ringNow.parentNode.removeChild(ringNow)
      const trailNow = document.getElementById('cursor-trail')
      if (trailNow && trailNow.parentNode) trailNow.parentNode.removeChild(trailNow)
      delete document.documentElement.dataset.lampBound
    } catch (_) {}
  }
}

// Expose initializer for theme toggle re-initialization
if (typeof window !== "undefined") {
  window.__initUnderwaterLampCursor = initUnderwaterLampCursor;
}

// Force scroll to top on route changes unless navigating to a hash anchor
export const shouldUpdateScroll = ({ routerProps }) => {
  try {
    const { location } = routerProps || {}
    const hasHash = location && typeof location.hash === "string" && location.hash.length > 1
    if (hasHash) return false
  } catch (_) {}
  // Let our own scroll handlers manage this; returning false prevents Gatsby from restoring
  // previous scroll positions that may fight with our top resets.
  return false
}